export default class Note {
  value: string
  noteType: string
  noteTypeName: string
  createdDate: string
  createdById: string
  createdByName: string
  clientId: string

  valueObject: object

  constructor (instance: any) {
    this.value = instance.value
    this.noteType = instance.noteType
    this.noteTypeName = instance.noteTypeName
    this.clientId = instance.clientId

    this.createdDate = instance.createdDate
    this.createdById = instance.createdById
    this.createdByName = instance.createdByName

    if (instance.noteType === 30 || instance.noteType === 40) {
      this.valueObject = JSON.parse(instance.value)
    }
  }
}
